import { Helmet } from "react-helmet-async";

export default function Seo({ title, description }) {
  const fullTitle = title ? `${title} | Trendsight Media` : "Trendsight Media — Media & Social Media Marketing, Delhi";
  const desc = description || "Trendsight Media is a Delhi-based media and social media marketing company helping brands, businesses and creators grow visibility, engagement and influence.";
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
    </Helmet>
  );
}
